import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Observer from './libs/Observer';
import slider from './libs/Slider';
import { cardSlider } from './libs/cardSlider';
import Drawer from './libs/drawer';
import checkBreakPoint from './libs/isMatch';
import {
  fadeScale,
  homeParallax,
  introCircle,
  loadAddClass,
  scrollDirection,
  setScrollbarWidth,
  stickyScroll,
  stickyScrollSp,
} from './libs/utility';
import { footerBounce, interviewImageHover } from './libs/utility';

// ScrollTrigger をグローバルに公開（window.load で使用）
window.ScrollTrigger = ScrollTrigger;

// loadAddClass は即座に実行（window load/DOMContentLoaded イベントリスナーを登録）
loadAddClass();

// すべての初期化処理を DOMContentLoaded 後に実行
document.addEventListener('DOMContentLoaded', () => {
  const breakPoint = 1024;
  const isMatch = checkBreakPoint(breakPoint);

  // Drawer の初期化（最優先）
  new Drawer();

  // スクロールバー幅の設定（レイアウトシフト防止）
  setScrollbarWidth();

  // ブレークポイント判定後の処理
  if (isMatch()) {
    //pcの処理
    stickyScroll();
    homeParallax();
  } else {
    cardSlider("[data-swiper-group='business']");
    //spの処理
    stickyScrollSp();
    const _contributionObserver = new Observer(
      '.js-contribution-scroll',
      {
        rootMargin: '0% 0% -20% 0%',
        threshold: 0,
      },
      true,
      false
    );
    const _hintObserver = new Observer(
      '.js-hintObserver',
      {
        rootMargin: '0% 0% -60% 0%',
        threshold: 0,
      },
      true,
      false
    );
  }

  // Observer の初期化
  const _fadeInObserver = new Observer(
    '.js-fadein',
    {
      rootMargin: '0% 0% -20% 0%',
      threshold: 0,
    },
    false,
    true
  );

  // その他の初期化処理
  slider();
  introCircle();
  scrollDirection();
  interviewImageHover();
  footerBounce();

  // fadeScale アニメーションは遅延実行
  setTimeout(() => {
    fadeScale();
  }, 700);

  // facilities スライダー
  cardSlider("[data-swiper-group='facilities']", {
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      // when window width is >= 480px
      480: {
        slidesPerView: 1,
      },
      // when window width is >= 768px
      768: {
        spaceBetween: 0,
        slidesPerView: 2.5,
      },
      // when window width is >= 992px
      992: {
        slidesPerView: 2.5,
      },
    },
  });
});

// window.load 後に ScrollTrigger を再計算（画像読み込み完了後）
window.addEventListener('load', () => {
  // GSAP の ScrollTrigger が利用可能な場合のみリフレッシュ
  if (window.ScrollTrigger) {
    window.ScrollTrigger.refresh();
  }
});
